import firebase from 'firebase/app'
import 'firebase/auth'
import store from '@/store'
import { Storage } from '@/utils/Storage'
import { removeCurrentDevice } from '@/utils/PushDevices'

export const logout = async (router = null) => {
    const uid = firebase.auth().currentUser?.uid || null
    store.commit('clearDialogs')
    await Storage.setCredentials(null)
    if (router) router.replace({ name: 'login' }).catch(() => { })
    if (uid) await removeCurrentDevice(uid)
    await firebase.auth().signOut()
}
